<template>
  <div>
    <training-member-toolbar />
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header
        :title="$t('trainings.participation_view')"
        :iconName="'file-earmark-text'"
      />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible>
          {{ this.successMessage }}
        </b-alert>
        <b-alert
          v-for="error in errors"
          :key="error.message"
          v-model="popAlert"
          variant="danger"
          dismissible
        >
          {{ error.message }}
        </b-alert>
        <template v-if="dataForForm.show">
          <b-overlay :show="isLoading" spinner-variant="primary" rounded="sm">
            <approve-reject-form
              @hide-form="hideForm"
              @approve-reject-participation="approveParticipation"
              @cancel-participation="cancelParticipation"
              :action="dataForForm.action"
              :participation="dataForForm.participation"
            />
          </b-overlay>
          <hr />
        </template>
        <template>
          <participation-filter @refresh-list="refreshList" :filters="this.filters" />
          <hr />
        </template>
        <b-skeleton-wrapper :loading="participations == null">
          <template #loading>
            <trainings-table-skeleton />
          </template>
          <template>
            <participations-table
              @show-form="showForm"
              :participations="participations"
              :actions="actions"
            />
          </template>
        </b-skeleton-wrapper>
      </b-card-body>
    </div>
  </div>
</template>

<script>
import CardHeader from "../../components/common/cardHeader.vue";
import trainingService from "../../services/training.service";
import { handleApiError, makeErrorToast, makeToast } from "../../services/error.service";
import ParticipationsTable from "../../components/participation/participationsTable.vue";
import TrainingsTableSkeleton from "../../components/trainings/trainingsTableSkeleton.vue";
import axios from "axios";
import ParticipationFilter from "@/components/participation/participationFilter";
import ApproveRejectForm from "../../components/participation/approveRejectForm.vue";
import TrainingMemberToolbar from "@/components/TrainingMemberToolbar";

export default {
  computed: {
    accessibleUnits: function () {
      let units = this.$store.state.usersAccessibleUnits.map((unit) => ({
        label: unit.name,
        id: unit.id,
        type: unit.type,
      }));
      return units;
    },
  },
  components: {
    ParticipationFilter,
    CardHeader,
    ParticipationsTable,
    TrainingMemberToolbar,
    TrainingsTableSkeleton,
    ApproveRejectForm,
  },
  mounted() {
    if ("memberId" in this.$route.query && !this.$store.state.globalUnitId) {
      this.criteria.memberId = this.$route.query.memberId;
      this.criteria.status = null;
    }
    if ("participationId" in this.$route.query) {
      this.criteria.participationId = this.$route.query.participationId;
      this.criteria.status = null;
    }

    this.getUnits();
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;

        this.$store.state.userInfo = this.userInfo;

        this.criteriaInitialized = true;
        this.getParticipations(this.criteria);
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
  },
  data() {
    return {
      unitsPermission: null,
      actions: {
        view: false,
        apply: true,
      },
      filters: {
        status: true,
        date: true,
        search: true,
      },
      depositTypes: [
        { value: "RF_CODE", text: this.$t("paymentTypeEnums.RF_CODE"), enabled: true },
        {
          value: "IN_PERSON",
          text: this.$t("paymentTypeEnums.IN_PERSON"),
          enabled: true,
        },
        {
          value: "ISLAND_DISCOUNT",
          text: this.$t("paymentTypeEnums.ISLAND_DISCOUNT"),
          enabled: true,
        },
        { value: "BANK", text: this.$t("paymentTypeEnums.BANK"), enabled: true },
        {
          value: "FINANCE_DEP",
          text: this.$t("paymentTypeEnums.FINANCE_DEP"),
          enabled: true,
        },
        { value: "NONE", text: this.$t("paymentTypeEnums.NONE"), enabled: false },
      ],
      activeMembers: [],
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      participations: null,
      showApplyForm: false,
      depositDisabled: false,
      criteria: {
        search: null,
        status: "UNDER_REVIEW",
        startDate: null,
        endDate: null,
        unitId: null,
        memberId: null,
        includeSubs: false,
      },
      participation: {
        member: null,
        paymentType: { value: "NONE", text: this.$t("paymentTypeEnums.NONE") },
        activity: null,
        training: null,
        rfCode: null,
      },
      cancelSource: null,
      dataForForm: {
        show: false,
      },
      isLoading: false,
    };
  },
  methods: {
    getUnits() {
      trainingService.getUsersPermissions().then(
        (response) => {
          let trainUnits = response.data.VIEW_UNIT || [];

          if (trainUnits) {
            this.unitPermission = trainUnits.filter((unit) => unit.status == "ACTIVE");
          } else {
            this.unitPermission = [];
          }
          if (this.unitsPermission.length <= 1) {
            this.criteria.unit = this.unitsPermission[0];
          }
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit("error:api", errorMessage);
        }
      );
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleError(errors) {
      errors.forEach((error) => {
        error.message = this.$t(`error.${error.code}`);
      });
      this.errors = errors;
      this.popAlert = errors.length > 0;
    },
    refreshList(criteria) {
      this.criteria = criteria;
      this.getParticipations(criteria);
    },
    getMember(search, loading) {
      if (search.length < 1) {
        return;
      }
      loading(true);
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();
      trainingService
        .getMembersByCriteria(
          null,
          "REGISTERED",
          search,
          null,
          ["SUPPORT", "OLD_SCOUT"],
          this.cancelSource.token
        )
        .then(
          (response) => {
            this.activeMembers = response.data;
            this.activeMembers.map(function (e) {
              e.label = `${e.surName} ${e.firstName} (${e.id})`;
            });

            loading(false);
            this.cancelSource = null;
          },
          (error) => {
            if (error.message === "cancel") return;
            let errorMessage = handleApiError(error);
            loading(false);
            this.$emit("error:api", errorMessage);
          }
        );
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("cancel");
      }
    },
    getParticipations(criteria) {
      this.participations = null;
      trainingService
        .getParticipations(
          criteria.status,
          criteria.search,
          criteria.unit,
          criteria.memberId,
          criteria.participationId,
          criteria.includeSubs
        )
        .then(
          (response) => {
            this.participations = response.data;
            this.participations.forEach((e) => {
              this.canApproveParticipation(e);
            });
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.handleError(errorMessage);
          }
        );
    },
    showForm(data) {
      if (data.participation.activity.module.billMethod.rules[0]?.billingValue > 0) {
        data.participation.paymentType = data.participation.activity.paymentTypes[0];
      } else {
        data.participation.paymentType = "NONE";
      }
      this.scrollToTop();
      this.dataForForm = data;
      window.scrollTo(0, 0);
    },
    hideForm() {
      this.dataForForm = { show: false };
    },
    canApproveParticipation(participation) {
      trainingService.canApproveParticipation(participation.id).then((response) => {
        participation.canApprove = response.data.canApprove;
        this.participations = this.participations.map((e) => {
          if (e && e.id === participation.id) {
            e.canApprove = response.data.canApprove;
          }
          return e;
        });
      });
    },
    cancelParticipation() {
      this.isLoading = true;
      trainingService.cancelParticipation(this.dataForForm.participation.id).then(
        (response) => {
          this.participation = response.data;
          this.hideForm();
          this.refreshList(this.criteria);
          this.isLoading = false;
          makeToast(this.$bvToast, "Η συμμετοχή ακυρώθηκε");
        },
        (error) => {
          makeErrorToast(this.$bvToast, error);
          this.isLoading = false;
        }
      );
    },
    approveParticipation(data) {
      this.isLoading = true;
      trainingService
        .approveParticipation(
          this.dataForForm.participation.id,
          data.approved,
          data.participation.paymentType,
          data.participation.depositNo,
          data.participation.depositComments
        )
        .then(
          (response) => {
            this.participation = response.data;
            this.hideForm();
            this.refreshList(this.criteria);
            this.isLoading = false;
            makeToast(
              this.$bvToast,
              data.approved
                ? "Η συμμετοχή εγκρίθηκε με επιτυχία"
                : "Η συμμετοχή απορρίφθηκε με επιτυχία."
            );
          },
          (error) => {
            makeErrorToast(this.$bvToast, error);
            this.isLoading = false;
          }
        );
    },
  },
};
</script>
